import { colors } from '../../colors';
var para = {
  messageColor: colors.equineStone
};
export default para;